/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : Authorize.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Authorize component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Loader } from "@scuf/common";
import { useAuth } from "./AuthProvider";

export const Authorize: FC = () => {
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    if (login !== undefined) {
      login(location);
    }

    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Loader text="Login into APM Settings Tool...." overlayColor="#a0a0a0">
        <div className="placeholder" />
      </Loader>
    </div>
  );
};
